import imgKStadiumMark from '../assets/img/kstadium-mark.png';

export type WalletProviderSymbol = 'METAMASK' | 'KSTADIUM';

export interface WalletProvider {
  symbol: WalletProviderSymbol;
  name: string;
  logoUrl?: string;
  downloadUrl: string;
}

const walletProviders: WalletProvider[] = [
  {
    symbol: `METAMASK`,
    name: `MetaMask`,
    logoUrl: `/dummy/metamask.png`,
    downloadUrl: `https://chrome.google.com/webstore/detail/metamask/nkbihfbeogaeaoehlefnkodbefgpgknn`,
  },
  {
    symbol: `KSTADIUM`,
    name: `K STADIUM Wallet`,
    logoUrl: imgKStadiumMark,
    downloadUrl: `https://kstadium.io/`,
  },
];

export const findWalletProviderBySymbol = (
  symbol: string,
): WalletProvider | undefined =>
  walletProviders.find((provider) => provider.symbol === symbol);

export default walletProviders;
